"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockCronosOracleFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "disableException",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "latestRoundData",
        outputs: [
            {
                internalType: "uint80",
                name: "",
                type: "uint80",
            },
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint80",
                name: "",
                type: "uint80",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "_answer",
                type: "int256",
            },
        ],
        name: "setAnswer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint80",
                name: "_answeredInRound",
                type: "uint80",
            },
        ],
        name: "setAnsweredInRound",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_decimals",
                type: "uint8",
            },
        ],
        name: "setDecimals",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_exceptionMessage",
                type: "string",
            },
        ],
        name: "setException",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint80",
                name: "_roundId",
                type: "uint80",
            },
        ],
        name: "setRoundId",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_startedAtDelay",
                type: "uint256",
            },
        ],
        name: "setStartedAtDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_updatedAtDelay",
                type: "uint256",
            },
        ],
        name: "setUpdatedAtDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b5061052e806100206000396000f3fe608060405234801561001057600080fd5b506004361061008e5760003560e01c80630368dc9c1461009357806319f60e5a146100a4578063313ce567146100de5780633f22462a1461010257806350eba9dc1461011557806354a3daed146101285780635bbfdd021461013b5780637a1395aa1461016b57806399213cd81461018f578063feaf968c146101a2575b600080fd5b6100a26005805460ff19169055565b005b6100a26100b23660046103cd565b600280546001600160501b03909216600160501b02600160501b600160a01b0319909216919091179055565b6000546100eb9060ff1681565b60405160ff90911681526020015b60405180910390f35b6100a2610110366004610321565b600455565b6100a2610123366004610321565b600355565b6100a2610136366004610339565b6101de565b6100a26101493660046103cd565b600280546001600160501b0319166001600160501b0392909216919091179055565b6100a26101793660046103a5565b6000805460ff191660ff92909216919091179055565b6100a261019d366004610321565b600155565b6101aa6101fc565b604080516001600160501b03968716815260208101959095528401929092526060830152909116608082015260a0016100f9565b6005805460ff191660011790556101f760068383610288565b505050565b600554600090819081908190819060069060ff16156102375760405162461bcd60e51b815260040161022e91906103f4565b60405180910390fd5b506002546001546003546001600160501b0390921691610257904261049a565b600454610264904261049a565b60025493999298509096509450600160501b9091046001600160501b031692509050565b828054610294906104bd565b90600052602060002090601f0160209004810192826102b657600085556102fc565b82601f106102cf5782800160ff198235161785556102fc565b828001600101855582156102fc579182015b828111156102fc5782358255916020019190600101906102e1565b5061030892915061030c565b5090565b5b80821115610308576000815560010161030d565b600060208284031215610332578081fd5b5035919050565b6000806020838503121561034b578081fd5b82356001600160401b0380821115610361578283fd5b818501915085601f830112610374578283fd5b813581811115610382578384fd5b866020828501011115610393578384fd5b60209290920196919550909350505050565b6000602082840312156103b6578081fd5b813560ff811681146103c6578182fd5b9392505050565b6000602082840312156103de578081fd5b81356001600160501b03811681146103c6578182fd5b6000602080835281845483600182811c91508083168061041557607f831692505b85831081141561043357634e487b7160e01b87526022600452602487fd5b87860183815260200181801561045057600181146104615761048b565b60ff1986168252878201965061048b565b60008b815260209020895b868110156104855781548482015290850190890161046c565b83019750505b50949998505050505050505050565b6000828210156104b857634e487b7160e01b81526011600452602481fd5b500390565b600181811c908216806104d157607f821691505b602082108114156104f257634e487b7160e01b600052602260045260246000fd5b5091905056fea26469706673582212204e63e5c9a0f7af026847712a56fa3800520f3af184f8280e69cc6b94b4f2558964736f6c63430008030033";
class MockCronosOracleFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MockCronosOracleFactory = MockCronosOracleFactory;
MockCronosOracleFactory.bytecode = _bytecode;
MockCronosOracleFactory.abi = _abi;
//# sourceMappingURL=MockCronosOracleFactory.js.map